import React, { Suspense, useEffect, } from 'react';
import './App.css';
import './Components/Shared/CustomInputField/CustomInputField.css';

import { Route, Routes, useNavigate, useSearchParams } from 'react-router-dom';

import { useThemeColor } from './hooks/useThemeColor';
import { usePinUpdateStatics } from './hooks/usePinUpdateStatics';

import { fetchLoginUserData, userDetail } from './Redux/userSlice';
import { useDispatch, useSelector } from 'react-redux';

import { setInnerLoaderFalse, setInnerLoaderTrue } from './Redux/loaderSlice';

import { routesListAuth, } from './Data/PinUpdateRoutingsData';

// custom-sweet-alert
import CustomSweetAlert2 from './Components/Shared/CustomSweetAlert/CustomSweetAlert2';
import SuccessDetails from './Components/Shared/DetailsModals/SuccessDetails/SuccessDetails';

import { AnimatePresence, motion } from "framer-motion";

// layouts
import PublicRoute from './Pages/PrivateRoute/PublicRoute';

// pages
import PinUpdate from './Pages/Auth/PinUpdate/PinUpdate';

const Loader = React.lazy(() => import('./Components/Shared/Loader/Loader'));
const Progressbar = React.lazy(() => import('./Components/Shared/Progressbar/Progressbar'));
const CustomAlert = React.lazy(() => import('./Components/Shared/CustomAlert/CustomAlert'));

// export const rootUrl = process.env.REACT_APP_BASE_URL;
export const localUrl = `http://192.168.0.209:81/`;
export const serverUrl = `https://glo365.app`;
// export const rootUrl = localUrl;
export const rootUrl = serverUrl;
export const userKey = "gsuserkeys";

export const RE_DIGIT = new RegExp(/^\d+$/);

function App() {

  const { appBG, progressBar, percentage, } = usePinUpdateStatics();
  const { colorMode } = useThemeColor();

  // console.log(process.env.REACT_APP_BASE_URL);

  const user = useSelector(userDetail);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams,] = useSearchParams();

  useEffect(() => {
    if (!user?.is_login) {
      const refFromParam = searchParams.get("ref");
      if (refFromParam) {
        localStorage.setItem("ref", refFromParam);
        // dispatch(setInnerLoaderTrue());
        navigate("/registration");
      }

      dispatch(setInnerLoaderFalse());
    }
    let stringValue = localStorage.getItem(userKey);
    if (stringValue !== null) {
      let value = JSON.parse(stringValue);

      localStorage.setItem(userKey, JSON.stringify({
        is_login: true,
        value: value?.value
      }));
      dispatch(setInnerLoaderTrue());
      // dispatch(fetchLoginUserData());
      // navigate("/");
    }
    dispatch(setInnerLoaderFalse());
  }, [dispatch, user?.is_login, searchParams, navigate]);

  useEffect(() => {
    dispatch(fetchLoginUserData());
    dispatch(setInnerLoaderFalse());
  }, [dispatch]);

  return (
    <Suspense
      fallback={
        <Loader show={true} />
      }
    >
      <div className={"App row g-0 justify-content-center " + colorMode} style={{ backgroundColor: "", backgroundImage: `url(${appBG && (rootUrl + appBG[0]?.image)})`, }}>
        {
          (
            percentage <= 100 &&
            progressBar
          ) ?
            <Progressbar percentage={percentage} />
            :
            <>
              <div className="centered-main-section" id="main">

                <AnimatePresence>
                  <motion.div
                    initial={{ opacity: 0, x: "-50%" }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: "50%" }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    <Routes>
                      <Route index element={<PublicRoute><PinUpdate /></PublicRoute>} />

                      {
                        (routesListAuth?.map((item, index) =>
                          <Route key={item?.id || index} path={item?.path} element={
                            <PublicRoute>
                              {item?.component}
                            </PublicRoute>
                          }
                          />
                        ))
                      }
                    </Routes>
                  </motion.div>
                </AnimatePresence>
              </div>
              <CustomAlert />
              <CustomSweetAlert2 />
              <SuccessDetails />
            </>
        }

      </div>
    </Suspense>
  );
}

export default App;
